import { RefreshCw, CheckCircle2, AlertTriangle, CloudOff } from 'lucide-react';
import { useSyncStore } from '@/stores/syncStore';
import { useConnectionStore } from '@/stores/connectionStore';
import { syncService } from '@/services/sync';
import { cn } from '@/lib/utils';

export function SyncIndicator({ className }: { className?: string }) {
  const status = useSyncStore((s) => s.status);
  const online = useConnectionStore((s) => s.online);

  let Icon = RefreshCw;
  let label = 'Idle';
  let color = 'text-brand-muted';
  let spin = false;

  if (!online) {
    Icon = CloudOff;
    label = 'Offline';
    color = 'text-brand-warn';
  } else if (status === 'syncing') {
    Icon = RefreshCw;
    label = 'Syncing';
    color = 'text-brand-primaryBlue';
    spin = true;
  } else if (status === 'success') {
    Icon = CheckCircle2;
    label = 'Synced';
    color = 'text-brand-delivery';
  } else if (status === 'failure') {
    Icon = AlertTriangle;
    label = 'Sync error';
    color = 'text-brand-error';
  }

  return (
    <button
      type="button"
      onClick={() => void syncService.runOnce('manual')}
      className={cn(
        'inline-flex items-center gap-2 rounded-button px-3 py-1 text-sm font-semibold',
        'bg-brand-surface hover:bg-brand-surfaceAlt transition-colors',
        color,
        className,
      )}
      aria-label="Sync status"
    >
      <Icon className={cn('h-4 w-4', spin && 'animate-spin')} />
      <span>{label}</span>
    </button>
  );
}
